import SafeHtml from "@lhd/components/SafeHtml";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { getConfigAppPartType } from "@lhd/features/Apps/utils";

interface IProps {
  item: AppPartType;
}

const LabelField = (props: IProps) => {
  const { item } = props;
  const { labelText } = getConfigAppPartType(item);
  const isLabelField = item.app_part_type === "label";

  return (
    <div
      className="label_container label_field"
      style={{ background: "rgb(255, 255, 255)" }}
    >
      <SafeHtml
        html={labelText || ""}
        style={{ padding: isLabelField ? "0px 5px" : "0px" }}
      />
    </div>
  );
};
export default LabelField;
